import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { decryptData } from "src/utils/decryptcookie";
import LoadingScreen from "../../../components/LoadingScreen.js";
import AuthGuard from "../../../guards/AuthGuard.js";
import DashboardLayout from "../../../layouts/dashboard/index.js";
import TestPage from "src/pages/Test/TestPage.js";
// import AgentTrack from "src/pages/dashboard/AgentTrack/AgentTrack.js";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  const isDashboard = pathname.includes("/dashboard");

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: "fixed",
            }),
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

const FlightInvoice = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/FlightInvoice.js"))
);
const HotelInvoice = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/HotelInvoice.js"))
);
const FlightInvoiceBreakdownPage = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/common/FlightInvoiceBreakdownPage.jsx"))
);
const HelpDesk = Loadable(
  lazy(() => import("src/pages/dashboard/HelpDesk.jsx"))
);
const RefundInvoice = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/RefundInvoice.js"))
);

// agent different routes than admin
const TransferPnr = Loadable(
  lazy(() =>
    import("../../../components/_dashboard/transferPnr/TransferPnr.js")
  )
);
const SuccessScreen = Loadable(
  lazy(() => import("src/pages/PayuScreen/SuccessScreen.js"))
);
const FailureScreen = Loadable(
  lazy(() => import("src/pages/PayuScreen/FailureScreen.js"))
);
// end

const AgentInvoice = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/FlightInvoice.js"))
);

const GeneralApp = Loadable(
  lazy(() => import("src/pages/dashboard/GeneralApp.js"))
);
const GeneralEcommerce = Loadable(
  lazy(() => import("src/pages/dashboard/GeneralEcommerce.js"))
);
const AgentDashboard = Loadable(
  lazy(() => import("src/pages/dashboard/Main/AgentDashboard.js"))
);
const GeneralAnalytics = Loadable(
  lazy(() => import("src/pages/dashboard/GeneralAnalytics.js"))
);
const GeneralBanking = Loadable(
  lazy(() => import("src/pages/dashboard/GeneralBanking.js"))
);
const GeneralBooking = Loadable(
  lazy(() => import("src/pages/dashboard/GeneralBooking.js"))
);

// const Travellersinfo = Loadable(
//   lazy(() => import("../../pages/dashboard/TravellersInfo"))
// );
const AgentToCheckRules = Loadable(
  lazy(() =>
    import(
      "../../../components/_dashboard/adminPages/AdminFareRuleChooseAgent.js"
    )
  )
);
const BulkData = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/Bulkdata.js"))
);
const ScrappyUser = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/AddScrappyUser.js"))
);
const ViewScrappyUser = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/ViewScappyUser.js"))
);
const GetMeta = Loadable(lazy(() => import("src/pages/Meta-mange.js")));
const AppliedRule = Loadable(
  lazy(() => import("src/pages/FareRule/ExistingFareRule.js"))
);
const ViewAllData = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/ViewData.js"))
);
const AddIternary = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/AddIternary.js"))
);
const Approval = Loadable(
  lazy(() => import("src/pages/PaymentRequests/approval.js"))
);
const AllRequest = Loadable(
  lazy(() => import("src/pages/PaymentRequests/AllRequest.js"))
);
const ChooseAgent = Loadable(
  lazy(() => import("src/pages/AccountTranscation/ChooseAgent.js"))
);
const AgentLedger = Loadable(
  lazy(() => import("src/pages/AccountTranscation/AgentLedger.js"))
);
// const CreateBooking = Loadable(lazy(() => import("../../pages/BookingApi")));
const Cancellations = Loadable(
  lazy(() => import("src/pages/cancellations.js"))
);

const AgentWallet = Loadable(
  lazy(() =>
    import("src/pages/RelationshipManager/AgentSection/AgentWallet.js")
  )
);
const SubAgentTable = Loadable(
  lazy(() => import("src/pages/AgentPortal/SubAgentTable.js"))
);
const AddAgentInfo = Loadable(
  lazy(() => import("src/pages/AgentPortal/AddSubAgent.js"))
);
const EditSubAgent = Loadable(
  lazy(() => import("src/pages/AgentPortal/EditSubAgent.js"))
);
const AddSubAgentLimit = Loadable(
  lazy(() => import("src/pages/AgentPortal/AddSubAgentLimit.js"))
);
const SubAgentProfile = Loadable(
  lazy(() => import("src/pages/AgentPortal/SubAgentProfile.js"))
);
const SubAgentWallet = Loadable(
  lazy(() => import("src/pages/AgentPortal/SubAgentWallet.js"))
);

const TransactionPage = Loadable(
  lazy(() => import("src/pages/AccountsDepartment/TransactionPage.js"))
);

const HotelBookingTablePage = Loadable(
  lazy(() => import("src/pages/hotels/menu/HotelBookingTablePage.js"))
);

const AmendmentPage = Loadable(
  lazy(() => import("src/pages/AgentPortal/AmendmentPage.js"))
);
const Amendments = Loadable(
  lazy(() => import("src/pages/InhouseAgents/Amendments.js"))
);

//Harsh

// Main
const FlightBooking = Loadable(
  lazy(() => import("src/pages/Flightbooking.js"))
);
const HotelBooking = Loadable(
  lazy(() => import("src/pages/hotels/menu/HotelBookingPage.js"))
);

const Topup = Loadable(
  lazy(() => import("../../../components/_dashboard/Transaction/TopUp.js"))
);

const Alltransaction = Loadable(
  lazy(() => import("src/pages/PaymentRequests/AgentTransactions.js"))
);
const BookingsHistory = Loadable(
  lazy(() => import("src/pages/Bookings/userBookings.js"))
);
const BookingHome = Loadable(
  lazy(() => import("src/pages/dashboard/BookingHome/BookingHome.jsx"))
);

const UserProfile = Loadable(
  lazy(() => import("../../../pages/dashboard/UserProfile.js"))
);
const LoginActivityTracker = Loadable(
  lazy(() => import("src/pages/LoginActivity/LoginActivityTracker.jsx"))
);

export const AgentRoutes = () => {
  const parsedData = decryptData("_b60-g6fr_plus");

  return {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),

    children: [
      {
        path: "",
        // element: (
        // element: <Navigate to={"/dashboard/sub-agent-info"} replace />,
        element: <Navigate to={"/dashboard/flight_booking"} replace />,
      },
      { path: "main", element: <AgentDashboard /> },
      { path: "test", element: <TestPage /> },
      { path: "help-desk", element: <HelpDesk /> },
      { path: "refund-invoice", element: <RefundInvoice /> },
      { path: "user-profile", element: <UserProfile /> },
      { path: "sub-agent-info", element: <SubAgentTable /> },
      { path: "flight_booking", element: <FlightBooking /> },
      { path: "hotel_booking", element: <HotelBooking /> },
      { path: "flight-invoice-breakdown", element: <FlightInvoiceBreakdownPage /> },

      { path: "invoice_flight", element: <FlightInvoice /> },
      { path: "invoice_hotel", element: <HotelInvoice /> },

      { path: "invoice", element: <AgentInvoice /> },

      { path: "topup", element: <Topup /> },

      { path: "bookingsHistory", element: <BookingsHistory /> },
      { path: "booking-home", element: <BookingHome /> },
      { path: "approval", element: <Approval /> },
      { path: "alltransaction", element: <Alltransaction /> },
      { path: "chooseAgent", element: <ChooseAgent /> },
      { path: "agentLedger", element: <AgentLedger /> },
      { path: "cancellations", element: <Cancellations /> },
      // { path: "checkAgentRules", element: <AgentToCheckRules /> },
      // { path: "scrap-all-data", element: <ViewAllData /> },
      // { path: "add-Iternary", element: <AddIternary /> },
      // { path: "add-bulk-data", element: <BulkData /> },
      // { path: "add-scrappy-user", element: <ScrappyUser /> },
      // { path: "view-scrappy-user", element: <ViewScrappyUser /> },
      // { path: "get-meta", element: <GetMeta /> },
      // { path: "agent-wallet", element: <AgentWallet /> },
      // { path: "all-requests", element: <AllRequest /> },
      { path: "sub-agent-info", element: <SubAgentTable /> },
      { path: "add-sub-agent-info", element: <AddAgentInfo /> },
      { path: "edit-sub-agent-info", element: <EditSubAgent /> },
      { path: "add-sub-agent-limit", element: <AddSubAgentLimit /> },
      { path: "sub-agent-profile", element: <SubAgentProfile /> },
      { path: "sub-agent-wallet", element: <SubAgentWallet /> },
      { path: "raise-a-query", element: <AmendmentPage /> },
      { path: "get-all-amendments", element: <Amendments /> },
      { path: "accounts-all-requests", element: <TransactionPage /> },
      { path: "login-activity", element: <LoginActivityTracker /> },
      // { path: "paymentsuccess", element: <SuccessScreen /> },
      // { path: "paymentfailure", element: <FailureScreen /> },
      { path: "transfer-pnr", element: <TransferPnr /> },
      // new route
      {
        path: "all-booking-details-hotels",
        element: <HotelBookingTablePage />,
      },
      // {
      //   path: "all-booking-details-transfers",
      //   element: <BookingTablePageTransfers />,
      // },
      // {
      //   path: "get-all-amendments-hotels",
      //   element: <AmendmentsHotels />,
      // },
    ],
  };
};
